// Enhanced Vehicle Database with comprehensive EV models from Zynka-Web-old
// Organized by brand with complete specifications and images

export const enhancedVehicleDatabase = {
  Tesla: {
    brandLogo: '/assets/carModelsLogo/Tesla.png',
    color: '#e53e3e',
    models: [
      {
        id: 'tesla-model-3',
        name: 'Tesla Model 3',
        image: '/assets/carModelssLogo/tesla_model_3.png',
        range: 358,
        batteryCapacity: 60,
        consumption: 145, // Wh/km
        fastChargingPower: 250,
        weight: 1611,
        type: 'Sedan',
        year: '2024'
      },
      {
        id: 'tesla-model-y-2025',
        name: 'Tesla Model Y 2025',
        image: '/assets/carModelssLogo/tesla_model_y.png',
        range: 500,
        batteryCapacity: 75,
        consumption: 150, // Wh/km
        fastChargingPower: 250,
        weight: 2000,
        type: 'SUV',
        year: '2025'
      },
      {
        id: 'tesla-model-s',
        name: 'Tesla Model S',
        image: '/assets/carModelssLogo/tesla_model_3.png',
        range: 405,
        batteryCapacity: 100,
        consumption: 185, // Wh/km
        fastChargingPower: 250,
        weight: 2108,
        type: 'Sedan',
        year: '2024'
      },
      {
        id: 'tesla-model-x',
        name: 'Tesla Model X',
        image: '/assets/carModelssLogo/tesla_model_y.png',
        range: 348,
        batteryCapacity: 100,
        consumption: 208, // Wh/km
        fastChargingPower: 250,
        weight: 2459,
        type: 'SUV',
        year: '2024'
      }
    ]
  },
  
  Tata: {
    brandLogo: '/assets/carModelsLogo/Tata.png',
    color: '#1e3a8a',
    models: [
      {
        id: 'tata-nexon-ev-creative',
        name: 'Nexon EV Creative',
        image: '/assets/carModelssLogo/tata_nexon_ev.png',
        range: 275,
        batteryCapacity: 45,
        consumption: 164, // Wh/km
        fastChargingPower: 50,
        weight: 1400,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'tata-nexon-ev-empowered',
        name: 'Nexon EV Empowered',
        image: '/assets/carModelssLogo/tata_nexon_ev.png',
        range: 489,
        batteryCapacity: 46.08,
        consumption: 94, // Wh/km
        fastChargingPower: 60,
        weight: 1400,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'tata-nexon-ev-prime',
        name: 'Nexon EV Prime',
        image: '/assets/carModelssLogo/tata_nexon_ev.png',
        range: 312,
        batteryCapacity: 30.2,
        consumption: 156, // Wh/km
        fastChargingPower: 50,
        weight: 1400,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'tata-nexon-ev-max',
        name: 'Nexon EV Max',
        image: '/assets/carModelssLogo/tata_nexon_ev.png',
        range: 437,
        batteryCapacity: 40.5,
        consumption: 155, // Wh/km
        fastChargingPower: 50,
        weight: 1400,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'tata-punch-ev-standard',
        name: 'Punch EV Standard',
        image: '/assets/carModelssLogo/tata_punch_ev.png',
        range: 315,
        batteryCapacity: 25,
        consumption: 79, // Wh/km
        fastChargingPower: 50,
        weight: 1200,
        type: 'Hatchback',
        year: '2024'
      },
      {
        id: 'tata-punch-ev-long-range',
        name: 'Punch EV Long Range',
        image: '/assets/carModelssLogo/tata_punch_ev.png',
        range: 421,
        batteryCapacity: 35,
        consumption: 83, // Wh/km
        fastChargingPower: 50,
        weight: 1250,
        type: 'Hatchback',
        year: '2024'
      },
      {
        id: 'tata-tiago-ev',
        name: 'Tiago EV',
        image: '/assets/carModelssLogo/tata_tiago_ev.png',
        range: 250,
        batteryCapacity: 24,
        consumption: 120, // Wh/km
        fastChargingPower: 24,
        weight: 1235,
        type: 'Hatchback',
        year: '2024'
      },
      {
        id: 'tata-tiago-ev-long',
        name: 'Tiago EV Long Range',
        image: '/assets/carModelssLogo/tata_tiago_ev.png',
        range: 315,
        batteryCapacity: 24,
        consumption: 120, // Wh/km
        fastChargingPower: 24,
        weight: 1235,
        type: 'Hatchback',
        year: '2024'
      },
      {
        id: 'tata-curvv-ev',
        name: 'Curvv EV',
        image: '/assets/carModelssLogo/tata_curvv_ev.png',
        range: 502,
        batteryCapacity: 55,
        consumption: 110, // Wh/km
        fastChargingPower: 150,
        weight: 1600,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'tata-harrier-ev',
        name: 'Harrier EV',
        image: '/assets/carModelssLogo/tata-harrier-ev.png',
        range: 627,
        batteryCapacity: 75,
        consumption: 120, // Wh/km
        fastChargingPower: 120,
        weight: 1900,
        type: 'SUV',
        year: '2024'
      }
    ]
  },

  Mahindra: {
    brandLogo: '/assets/carModelsLogo/Mahindra.png',
    color: '#c41e3a',
    models: [
      {
        id: 'mahindra-e-verito',
        name: 'e-Verito',
        image: '/assets/carModelssLogo/mahindra_everito.png',
        range: 140,
        batteryCapacity: 21.2,
        consumption: 151, // Wh/km
        fastChargingPower: 15,
        weight: 1350,
        type: 'Sedan',
        year: '2024'
      },
      {
        id: 'mahindra-e2o-plus',
        name: 'e2o Plus',
        image: '/assets/carModelssLogo/mahindra-e2o-plusl.png',
        range: 140,
        batteryCapacity: 10.08,
        consumption: 112, // Wh/km
        fastChargingPower: 15,
        weight: 830,
        type: 'Hatchback',
        year: '2024'
      },
      {
        id: 'mahindra-xuv400-ev',
        name: 'XUV400 EV',
        image: '/assets/carModelssLogo/mahindra_xuv400.png',
        range: 456,
        batteryCapacity: 39.4,
        consumption: 86, // Wh/km
        fastChargingPower: 50,
        weight: 1578,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'mahindra-be-6',
        name: 'BE 6',
        image: '/assets/carModelssLogo/mahindra_be6.png',
        range: 557,
        batteryCapacity: 59,
        consumption: 106, // Wh/km
        fastChargingPower: 140,
        weight: 1907,
        type: 'SUV',
        year: '2025'
      },
      {
        id: 'mahindra-xev-9e',
        name: 'XEV 9e',
        image: '/assets/carModelssLogo/mahindra_xev9e.png',
        range: 542,
        batteryCapacity: 59,
        consumption: 109, // Wh/km
        fastChargingPower: 180,
        weight: 2201,
        type: 'SUV',
        year: '2025'
      },
      {
        id: 'mahindra-xuv-e8',
        name: 'XUV.e8',
        image: '/assets/carModelssLogo/mahindra_xuv400.png',
        range: 450,
        batteryCapacity: 60,
        consumption: 133, // Wh/km
        fastChargingPower: 175,
        weight: 1900,
        type: 'SUV',
        year: '2025'
      },
      {
        id: 'mahindra-xuv-e9',
        name: 'XUV.e9',
        image: '/assets/carModelssLogo/mahindra_xuv400.png',
        range: 480,
        batteryCapacity: 80,
        consumption: 167, // Wh/km
        fastChargingPower: 175,
        weight: 2000,
        type: 'SUV',
        year: '2025'
      },
      {
        id: 'mahindra-be-05',
        name: 'BE.05',
        image: '/assets/carModelssLogo/mahindra_be6.png',
        range: 400,
        batteryCapacity: 60,
        consumption: 150, // Wh/km
        fastChargingPower: 150,
        weight: 1800,
        type: 'SUV',
        year: '2025'
      },
      {
        id: 'mahindra-be-07',
        name: 'BE.07',
        image: '/assets/carModelssLogo/mahindra_be6.png',
        range: 450,
        batteryCapacity: 80,
        consumption: 178, // Wh/km
        fastChargingPower: 175,
        weight: 1950,
        type: 'SUV',
        year: '2025'
      },
      {
        id: 'mahindra-be-09',
        name: 'BE.09',
        image: '/assets/carModelssLogo/mahindra_be6.png',
        range: 500,
        batteryCapacity: 90,
        consumption: 180, // Wh/km
        fastChargingPower: 200,
        weight: 2100,
        type: 'SUV',
        year: '2025'
      }
    ]
  },

  Hyundai: {
    brandLogo: '/assets/carModelsLogo/Hyundai.png',
    color: '#003d7a',
    models: [
      {
        id: 'hyundai-kona-electric',
        name: 'Kona Electric',
        image: '/assets/carModelssLogo/hyundai_kona.png',
        range: 452,
        batteryCapacity: 39.2,
        consumption: 87, // Wh/km
        fastChargingPower: 77,
        weight: 1685,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'hyundai-ioniq-5',
        name: 'IONIQ 5',
        image: '/assets/carModelssLogo/hyundai_ioniq5.png',
        range: 631,
        batteryCapacity: 72.6,
        consumption: 115, // Wh/km
        fastChargingPower: 233,
        weight: 2060,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'hyundai-creta-ev-standard',
        name: 'Creta EV Standard',
        image: '/assets/carModelssLogo/hyundai_creta_ev.png',
        range: 390,
        batteryCapacity: 42,
        consumption: 108, // Wh/km
        fastChargingPower: 100,
        weight: 1700,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'hyundai-creta-ev-long-range',
        name: 'Creta EV Long Range',
        image: '/assets/carModelssLogo/hyundai_creta_ev.png',
        range: 473,
        batteryCapacity: 51.4,
        consumption: 109, // Wh/km
        fastChargingPower: 100,
        weight: 1750,
        type: 'SUV',
        year: '2024'
      }
    ]
  },

  MG: {
    brandLogo: '/assets/carModelsLogo/MG.png',
    color: '#d41e36',
    models: [
      {
        id: 'mg-zs-ev',
        name: 'ZS EV',
        image: '/assets/carModelssLogo/mg-zs-ev.png',
        range: 419,
        batteryCapacity: 50.3,
        consumption: 120, // Wh/km
        fastChargingPower: 87,
        weight: 1620,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'mg-zs-ev-excite',
        name: 'ZS EV Excite',
        image: '/assets/carModelssLogo/mg-zs-ev.png',
        range: 461,
        batteryCapacity: 50.3,
        consumption: 109, // Wh/km
        fastChargingPower: 87,
        weight: 1620,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'mg-comet-ev',
        name: 'Comet EV',
        image: '/assets/carModelssLogo/mg-comet-ev,.png',
        range: 230,
        batteryCapacity: 17.3,
        consumption: 75, // Wh/km
        fastChargingPower: 20,
        weight: 1150,
        type: 'Hatchback',
        year: '2024'
      },
      {
        id: 'mg-windsor-ev',
        name: 'Windsor EV',
        image: '/assets/carModelssLogo/mg-windsor-ev.png',
        range: 449,
        batteryCapacity: 52.9,
        consumption: 118, // Wh/km
        fastChargingPower: 87,
        weight: 1700,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'mg-m9-ev',
        name: 'M9 EV',
        image: '/assets/carModelssLogo/mg-m9-ev,.png',
        range: 548,
        batteryCapacity: 90,
        consumption: 164, // Wh/km
        fastChargingPower: 150,
        weight: 2400,
        type: 'MPV',
        year: '2024'
      },
      {
        id: 'mg-cyberster',
        name: 'Cyberster',
        image: '/assets/carModelssLogo/mg-cyberster.png',
        range: 580,
        batteryCapacity: 77,
        consumption: 133, // Wh/km
        fastChargingPower: 150,
        weight: 1985,
        type: 'Coupe',
        year: '2024'
      }
    ]
  },

  BMW: {
    brandLogo: '/assets/carModelsLogo/Bmw.png',
    color: '#0066cc',
    models: [
      {
        id: 'bmw-i3',
        name: 'i3',
        image: '/assets/carModelssLogo/bmw-i3.png',
        range: 260,
        batteryCapacity: 42.2,
        consumption: 162, // Wh/km
        fastChargingPower: 50,
        weight: 1365,
        type: 'Hatchback',
        year: '2024'
      },
      {
        id: 'bmw-ix',
        name: 'iX',
        image: '/assets/carModelssLogo/bmw_ix.png',
        range: 425,
        batteryCapacity: 105.2,
        consumption: 247, // Wh/km
        fastChargingPower: 195,
        weight: 2585,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'bmw-ix1',
        name: 'iX1',
        image: '/assets/carModelssLogo/bmw_ix.png',
        range: 531,
        batteryCapacity: 64.8,
        consumption: 122, // Wh/km
        fastChargingPower: 130,
        weight: 2020,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'bmw-i7-edrive50',
        name: 'i7 eDrive50',
        image: '/assets/carModelssLogo/bmw-i7-edrive50.png',
        range: 625,
        batteryCapacity: 101.7,
        consumption: 163, // Wh/km
        fastChargingPower: 195,
        weight: 2640,
        type: 'Sedan',
        year: '2024'
      }
    ]
  },

  Kia: {
    brandLogo: '/assets/carModelsLogo/Kia.png',
    color: '#05141f',
    models: [
      {
        id: 'kia-ev6',
        name: 'EV6',
        image: '/assets/carModelssLogo/kia-ev6.png',
        range: 708,
        batteryCapacity: 77.4,
        consumption: 109, // Wh/km
        fastChargingPower: 233,
        weight: 2055,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'kia-carens-clavis-ev',
        name: 'Carens Clavis EV',
        image: '/assets/carModelssLogo/kia-carens-clavis-ev.png',
        range: 490,
        batteryCapacity: 51.4,
        consumption: 105, // Wh/km
        fastChargingPower: 100,
        weight: 1650,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'kia-ev9',
        name: 'EV9',
        image: '/assets/carModelssLogo/kia-ev9.png',
        range: 561,
        batteryCapacity: 99.8,
        consumption: 178, // Wh/km
        fastChargingPower: 233,
        weight: 2600,
        type: 'SUV',
        year: '2024'
      }
    ]
  },

  BYD: {
    brandLogo: '/assets/carModelsLogo/Byd.png',
    color: '#d97706',
    models: [
      {
        id: 'byd-atto-3',
        name: 'BYD Atto 3',
        image: '/assets/carModelssLogo/byd_atto_3.png',
        range: 521,
        batteryCapacity: 60.48,
        consumption: 116, // Wh/km
        fastChargingPower: 80,
        weight: 1750,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'byd-e6',
        name: 'BYD E6',
        image: '/assets/carModelssLogo/byd-e6.png',
        range: 520,
        batteryCapacity: 71.7,
        consumption: 138, // Wh/km
        fastChargingPower: 60,
        weight: 2300,
        type: 'MPV',
        year: '2024'
      },
      {
        id: 'byd-seal-dynamic',
        name: 'BYD Seal Dynamic',
        image: '/assets/carModelssLogo/byd-seal.png',
        range: 510,
        batteryCapacity: 61.44,
        consumption: 120, // Wh/km
        fastChargingPower: 150,
        weight: 1875,
        type: 'Sedan',
        year: '2024'
      },
      {
        id: 'byd-seal-premium',
        name: 'BYD Seal Premium',
        image: '/assets/carModelssLogo/byd-seal.png',
        range: 650,
        batteryCapacity: 82.56,
        consumption: 127, // Wh/km
        fastChargingPower: 150,
        weight: 1945,
        type: 'Sedan',
        year: '2024'
      },
      {
        id: 'byd-sealion-7',
        name: 'BYD Sealion 7',
        image: '/assets/carModelssLogo/byd-sealion-7.png',
        range: 567,
        batteryCapacity: 82.56,
        consumption: 146, // Wh/km
        fastChargingPower: 150,
        weight: 2200,
        type: 'SUV',
        year: '2024'
      }
    ]
  },

  Audi: {
    brandLogo: '/assets/carModelsLogo/Audi.png',
    color: '#7c2d12',
    models: [
      {
        id: 'audi-e-tron',
        name: 'Audi e-tron',
        image: '/assets/carModelssLogo/audi-e-tron.png',
        range: 365,
        batteryCapacity: 95,
        consumption: 260, // Wh/km
        fastChargingPower: 150,
        weight: 2565,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'audi-q8-etron',
        name: 'Audi Q8 e-tron',
        image: '/assets/carModelssLogo/audi-q8-etron.png',
        range: 582,
        batteryCapacity: 114,
        consumption: 196, // Wh/km
        fastChargingPower: 170,
        weight: 2720,
        type: 'SUV',
        year: '2024'
      }
    ]
  },

  'Mercedes-Benz': {
    brandLogo: '/assets/carModelsLogo/Mercedes.png',
    color: '#1f2937',
    models: [
      {
        id: 'mercedes-eqa',
        name: 'Mercedes-Benz EQA',
        image: '/assets/carModelssLogo/mercedes-eqs.png',
        range: 426,
        batteryCapacity: 66.5,
        consumption: 156, // Wh/km
        fastChargingPower: 100,
        weight: 2040,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'mercedes-eqs-450',
        name: 'Mercedes-Benz EQS 450+',
        image: '/assets/carModelssLogo/mercedes-eqs.png',
        range: 685,
        batteryCapacity: 118,
        consumption: 172, // Wh/km
        fastChargingPower: 160,
        weight: 2545,
        type: 'Sedan',
        year: '2024'
      },
      {
        id: 'mercedes-eqs-suv-450',
        name: 'Mercedes-Benz EQS SUV 450',
        image: '/assets/carModelssLogo/mercedes-eqs.png',
        range: 820,
        batteryCapacity: 122,
        consumption: 149, // Wh/km
        fastChargingPower: 200,
        weight: 2700,
        type: 'SUV',
        year: '2024'
      }
    ]
  },

  Nissan: {
    brandLogo: '/assets/carModelsLogo/Nissan.png',
    color: '#dc2626',
    models: [
      {
        id: 'nissan-leaf',
        name: 'Nissan LEAF',
        image: '/assets/carModelssLogo/nissan-leaf.png',
        range: 270,
        batteryCapacity: 40,
        consumption: 148, // Wh/km
        fastChargingPower: 46,
        weight: 1580,
        type: 'Hatchback',
        year: '2024'
      }
    ]
  },

  Citroen: {
    brandLogo: '/assets/carModelsLogo/Citroen.png',
    color: '#991b1b',
    models: [
      {
        id: 'citroen-ec3',
        name: 'Citroen eC3',
        image: '/assets/carModelssLogo/citroen-ec3.png',
        range: 320,
        batteryCapacity: 29.2,
        consumption: 91, // Wh/km
        fastChargingPower: 25,
        weight: 1316,
        type: 'Hatchback',
        year: '2024'
      }
    ]
  },

  Volvo: {
    brandLogo: '/assets/carModelsLogo/Volvo.png',
    color: '#0369a1',
    models: [
      {
        id: 'volvo-xc40-recharge',
        name: 'Volvo XC40 Recharge',
        image: '/assets/carModelssLogo/volvo-xc40.png',
        range: 418,
        batteryCapacity: 78,
        consumption: 187, // Wh/km
        fastChargingPower: 150,
        weight: 2158,
        type: 'SUV',
        year: '2024'
      }
    ]
  },

  'Maruti Suzuki': {
    brandLogo: '/assets/carModelsLogo/Maruti-suzuki.png',
    color: '#059669',
    models: [
      {
        id: 'maruti-e-vitara',
        name: 'Maruti Suzuki e Vitara',
        image: '/assets/carModelssLogo/default-car.png',
        range: 500,
        batteryCapacity: 61,
        consumption: 122, // Wh/km
        fastChargingPower: 135,
        weight: 1702,
        type: 'SUV',
        year: '2025'
      }
    ]
  },

  VinFast: {
    brandLogo: '/assets/carModelsLogo/Vinfast.png',
    color: '#7c3aed',
    models: [
      {
        id: 'vinfast-vf3',
        name: 'VinFast VF3',
        image: '/assets/carModelssLogo/vinfast-vf3.png',
        range: 210,
        batteryCapacity: 18.64,
        consumption: 89, // Wh/km
        fastChargingPower: 50,
        weight: 1200,
        type: 'Hatchback',
        year: '2024'
      },
      {
        id: 'vinfast-vf7',
        name: 'VinFast VF7',
        image: '/assets/carModelssLogo/vinfast-vf7.png',
        range: 450,
        batteryCapacity: 75,
        consumption: 167, // Wh/km
        fastChargingPower: 100,
        weight: 1900,
        type: 'SUV',
        year: '2024'
      }
    ]
  },

  'Rolls-Royce': {
    brandLogo: '/assets/carModelsLogo/Rolls-Royce.png',
    color: '#1f2937',
    models: [
      {
        id: 'rolls-royce-spectre',
        name: 'Rolls-Royce Spectre',
        image: '/assets/carModelssLogo/rolls-royce-spectre.png',
        range: 530,
        batteryCapacity: 102,
        consumption: 192, // Wh/km
        fastChargingPower: 195,
        weight: 2890,
        type: 'Coupe',
        year: '2024'
      }
    ]
  },

  Porsche: {
    brandLogo: '/assets/carModelsLogo/Porsche.png',
    color: '#facc15',
    models: [
      {
        id: 'porsche-taycan-turbo-s',
        name: 'Porsche Taycan Turbo S',
        image: '/assets/carModelssLogo/porsche-taycan-turbo-s.png',
        range: 560,
        batteryCapacity: 93.4,
        consumption: 167, // Wh/km
        fastChargingPower: 270,
        weight: 2295,
        type: 'Sedan',
        year: '2024'
      }
    ]
  },

  Leapmotor: {
    brandLogo: '/assets/carModelsLogo/Leapmotor.png',
    color: '#059669',
    models: [
      {
        id: 'leapmotor-c10-comfort',
        name: 'Leapmotor C10 Comfort',
        image: '/assets/carModelssLogo/default-car.png',
        range: 410,
        batteryCapacity: 52.9,
        consumption: 129, // Wh/km
        fastChargingPower: 84,
        weight: 1980,
        type: 'SUV',
        year: '2024'
      },
      {
        id: 'leapmotor-c10-long-range',
        name: 'Leapmotor C10 Long Range',
        image: '/assets/carModelssLogo/default-car.png',
        range: 530,
        batteryCapacity: 69.9,
        consumption: 132, // Wh/km
        fastChargingPower: 84,
        weight: 1980,
        type: 'SUV',
        year: '2024'
      }
    ]
  }
};

// Helper function to get all vehicles as a flat array
export const getAllVehicles = () => {
  const allVehicles = [];
  Object.keys(enhancedVehicleDatabase).forEach(brand => {
    enhancedVehicleDatabase[brand].models.forEach(model => {
      allVehicles.push({
        ...model,
        brand,
        brandLogo: enhancedVehicleDatabase[brand].brandLogo,
        brandColor: enhancedVehicleDatabase[brand].color
      });
    });
  });
  return allVehicles;
};

// Helper function to get vehicles by brand
export const getVehiclesByBrand = (brand) => {
  return enhancedVehicleDatabase[brand]?.models || [];
};

// Helper function to get vehicle by ID
export const getVehicleById = (id) => {
  const allVehicles = getAllVehicles();
  return allVehicles.find(vehicle => vehicle.id === id);
};